import { render } from "./PopUpFreeTrial.vue?vue&type=template&id=fdaa35ce"
import script from "./PopUpFreeTrial.vue?vue&type=script&lang=js"
export * from "./PopUpFreeTrial.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__